module.exports = __webpack_public_path__ + "img/expert.140aa3f7.png";